import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.level1,
    margin: "0 auto",
    flexGrow: "1",
    maxWidth: "600px",
    padding: "0 1rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0 1rem",
      padding: "0 0.5rem",
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  logo: {
    display: "block",
    padding: "2rem 0 0.5rem 0",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 100,
  },
  logoContainer: {
    width: "100%",
  },
  circularProgress: {
    position: "absolute",
    top: "20%",
    left: "48%",
    marginTop: -5,
    marginLeft: -5,
  },
}));
